import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Wizard from "common/components/Wizard/Wizard.jsx";
import wizardStepWithForm from "common/components/Wizard/wizardStepWithForm";

import EasyOpenInput from "common/components/EasyForm/EasyOpenInput";
import EasySelect from "common/components/EasyForm/EasySelect";
import EasyRegionDropdown from "common/components/EasyForm/EasyRegionDropdown";

// @material-ui/icons
import Check from "@material-ui/icons/Check";

// core components
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import store from "../../store"
import { showAlert } from "../../core-module/services/errorAlert/reducers"

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const style = {
  ...regularFormsStyle,
  termsText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "justify",
    border: "2px solid black",
    padding: "15px"
  },
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  },
  errorMessage: {
    color: "red"
  }
};

class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limChecked: false,
      termsChecked: false,
      error: false
    };
  }
  isValidated() {
    if (this.state.limChecked && this.state.termsChecked) {
      this.setState({ error: false });
      return true;
    }
    this.setState({ error: true });
    return false;
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>911 service limitations</h4>
          <div className={classes.termsText}>
            MCSnet VOIP offers a form of 9-1-1 service (9-1-1 Dialing) that is
            similar to traditional 9-1-1 (911) service but has some important
            differences and limitations when compared with enhanced 9-1-1
            service (E911) available in most locations in conjunction with
            traditional telephone service. With both traditional 9-1-1 and E911
            service, your call is sent directly to the nearest emergency
            response centre. In addition, with E911 service, your call back
            number and address are visible to the emergency response centre
            call-taker. With MCSnet VOIPs 9-1-1 service, your call is sent to a
            national emergency call centre. The call centre operator will
            request or confirm your location information and then transfer your
            9-1-1 call to the emergency response centre nearest your location.
            You should be prepared to provide or confirm your address and
            call-back number with the operator. Do not hang up unless told
            directly to do so and if disconnected, you should dial 9-1-1 again.
            You should ensure your location information, when registered with
            MCSnet, is kept current at all times. In case you are not able to
            speak during the 911 call, the call taker would dispatch emergency
            response vehicles to your last registered address. Remember that you
            need to update your 9-1-1 Dialing information if you move your
            device to a different location and/or if you add a new line to your
            account. Your 9-1-1 Dialing service is activated when you subscribe
            to MCSnet VOIP service. Remember that the 9-1-1 Dialing service will
            not function in the event of a power or broadband outage or if your
            broadband or ISP service is suspended or terminated. You should
            inform any household residents, guests and other persons who may be
            present at the physical location where you utilize the MCSnet VOIP
            service, of the important differences in and limitations of VoIP
            9-1-1 Dialing service as compared with E911 service, as set out
            above. We limit our liability to you in respect of our 911 Dialing
            service as we do not have any control over whether, or the manner in
            which, calls using our 911 Dialing service are answered or addressed
            by any local emergency response centre and we rely on third parties
            to assist us in routing 911 Dialing calls to local emergency
            response centres and to a national emergency calling centre. Prior
            to subscribing to MCSnet VOIP service, you must review the full text
            of applicable limitations of liability set out in the Terms of
            Service available here.
          </div>
          <div className={classes.checkboxAndRadio}>
            <FormControlLabel
              control={
                <Checkbox
                  tabIndex={-1}
                  checked={this.state.limChecked}
                  onClick={() =>
                    this.setState(prevState => ({
                      limChecked: !prevState.limChecked
                    }))
                  }
                  checkedIcon={<Check className={classes.checkedIcon} />}
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label="I acknowledge that I have read and understand the above notification of 9-1-1/E9-1-1 service limitations."
            />
          </div>
          <div className={classes.checkboxAndRadio}>
            <FormControlLabel
              control={
                <Checkbox
                  tabIndex={-1}
                  checked={this.state.termsChecked}
                  onClick={() =>
                    this.setState(prevState => ({
                      termsChecked: !prevState.termsChecked
                    }))
                  }
                  checkedIcon={<Check className={classes.checkedIcon} />}
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label="I accept the Terms of Service Agreement."
            />
          </div>
          {this.state.error ? (
            <div className={classes.errorMessage} key="errormessage">
              You need to accept the terms to proceed
            </div>
          ) : null}
        </GridItem>
      </GridContainer>
    );
  }
}

let formValues = ""

const Step2 = props => {
  if (
    props.connectForm.getValue("mode") === "" ||
    props.connectForm.getValue("mode") == null
  ) {
    return (
      <GridContainer justify="center">
        <GridItem xs={12}>
          <EasySelect propName="mode" connectForm={props.connectForm} />
        </GridItem>
      </GridContainer>
    );
  }

  let mode = Number(props.connectForm.getValue("mode"));

  formValues = props.connectForm

  return (
    <GridContainer justify="center">
      <GridItem xs={12}>
        <EasySelect propName="mode" connectForm={props.connectForm} />
      </GridItem>

      <GridItem xs={12} sm={6}>
        <EasyOpenInput propName="lastname" connectForm={props.connectForm} />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <EasyOpenInput propName="firstname" connectForm={props.connectForm} />
      </GridItem>

      {mode === 1 ? (
        <GridItem key="mode11" xs={12} sm={6}>
          <EasyOpenInput
            propName="streetnumber"
            connectForm={props.connectForm}
          />
        </GridItem>
      ) : (
        <div key="mode21" />
      )}

      {mode === 1 ? (
        <GridItem key="mode12" xs={12} sm={6}>
          <EasyOpenInput
            propName="streetname"
            connectForm={props.connectForm}
          />
        </GridItem>
      ) : (
        <GridItem key="mode22" xs={12}>
          <EasyOpenInput
            propName="ruraladdress"
            connectForm={props.connectForm}
          />
        </GridItem>
      )}

      {mode === 1 ? (
        <GridItem key="mode13" xs={12}>
          <EasyOpenInput propName="unit" connectForm={props.connectForm} />
        </GridItem>
      ) : (
        <GridItem key="mode23" xs={12}>
          <EasyOpenInput
            propName="ruraladditionalinfo"
            connectForm={props.connectForm}
          />
        </GridItem>
      )}

      <GridItem xs={4}>
        <EasyOpenInput propName="city" connectForm={props.connectForm} />
      </GridItem>
      <GridItem xs={4}>
        <EasyRegionDropdown
          propName="province"
          returnType="provinceshort"
          connectForm={props.connectForm}
        />
      </GridItem>
      <GridItem xs={4}>
        <EasyOpenInput propName="postalcode" connectForm={props.connectForm} />
      </GridItem>
      <GridItem xs={12}>
        <h4>{props.allStates.errorMessage}</h4>
      </GridItem>
    </GridContainer>
  );
};

const WizardStep1 = withStyles(style)(Step1);
const WizardStep2 = withStyles(style)(
  wizardStepWithForm(
    "user.session/billingpackage.props/emergencyprofile.props",
    Step2
  )
);

const EmergencyProfileWizard = props => {

  const onInvalidForm = () => {
    const getErrorMessage = () => {
      if(!formValues) 
        return ("Please select address type.")
      else 
        return (
          <div>
            <p>Please provide:</p>
            <List>
              {!formValues.getValue("city") ? 
                <ListItem>
                  <ListItemText primary="City"></ListItemText>
                </ListItem> 
              : null}
              {!formValues.getValue("firstname") ? 
                <ListItem>
                  <ListItemText primary="First name"></ListItemText>
                </ListItem> 
              : null}
              {!formValues.getValue("lastname") ? 
                <ListItem>
                  <ListItemText primary="Last name"></ListItemText>
                </ListItem> 
              : null}
              {!formValues.getValue("postalcode") ? 
                <ListItem>
                  <ListItemText primary="Postal Code"></ListItemText>
                </ListItem> 
              : null}
              {!formValues.getValue("province") ? 
                <ListItem>
                  <ListItemText primary="Province"></ListItemText>
                </ListItem> 
              : null}
            </List>
          </div>
        )
    }
    store.dispatch(showAlert(getErrorMessage())); 
  }

  return (
    <GridContainer justify="center">
      <GridItem xs={12} md={8}>
        <Wizard
          color="primary"
          steps={[
            {
              stepName: "Terms",
              stepComponent: WizardStep1,
              stepId: "terms"
            },
            {
              stepName: "Address",
              stepComponent: WizardStep2,
              stepId: "address"
            }
          ]}
          title="Emergency Profile"
          subtitle=""
          validate={true}
          startingStep={props.emergencyProfileStep}
          finishButtonClick={props.onFinishWizard}
          cancelButtonClick={props.closeWizard}
          allStates={{
            pathids: { ...props.pathids }
          }}
          onInvalidForm = {onInvalidForm}
        />
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(style)(EmergencyProfileWizard);
